// services/auth.js
import { API_BASE_URL } from './api/config';

class AuthService {
  
  // --- 1. Login Step 1: Credentials ---
  async login(username, password) {
    // Use API_BASE_URL imported from config
    const response = await fetch(`${API_BASE_URL}/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password }),
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || 'Login failed');
    }
    return data; 
  }

  // --- 2. Login Step 2: Verify 2FA ---
  async verify2FA(userId, code) {
    const response = await fetch(`${API_BASE_URL}/verify-2fa`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId, code }),
    });
    // ... rest of code
    const data = await response.json();
    if (!response.ok) throw new Error(data.message || 'Verification failed');
    return data;
  }

  // --- 3. Get Current User Profile ---
  async getProfile() {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('No token found');

    const response = await fetch(`${API_BASE_URL}/auth/me`, {
      method: 'GET',
      headers: { 
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
    });
    // ... rest of code
    const data = await response.json();
    if (!response.ok) {
      if (response.status === 401) throw new Error('SESSION_REVOKED');
      throw new Error(data.message || 'Failed to fetch profile');
    }
    return data;
  }

  // --- 4. Logout ---
  async logout() {
    const token = localStorage.getItem('token');
    if (!token) return;

    try {
      fetch(`${API_BASE_URL}/auth/logout`, { 
        method: 'POST',
        keepalive: true,
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}` 
        },
        body: JSON.stringify({}),
      });
    } catch (error) {
      console.error("Logout API call failed:", error);
    }
  }

  // ... (Update forgotPassword and resetPassword similarly)
  async forgotPassword(email) {
    const response = await fetch(`${API_BASE_URL}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.message);
    return data;
  }

  async resetPassword(token, newPassword) {
    const response = await fetch(`${API_BASE_URL}/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword }),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.message);
    return data;
  }
}

export const authService = new AuthService();
